var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter logo",
    clipPath: "url(#clip0_1537_339783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_b_1537_339783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 29.9997C23.2841 29.9997 29.9997 23.2841 29.9997 14.9999C29.9997 6.71567 23.2841 0 14.9999 0C6.71567 0 0 6.71567 0 14.9999C0 23.2841 6.71567 29.9997 14.9999 29.9997Z",
    fill: "#444444",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0076 13.4607C16.5522 12.8798 17.0847 12.317 17.6112 11.7542C18.3676 10.9433 19.1362 10.1445 19.8744 9.31547C20.0862 9.07946 20.298 8.97054 20.6067 9.00684C20.7761 9.025 20.9455 9.0129 21.2239 9.0129C19.6082 10.7436 18.053 12.4199 16.4735 14.1143C18.174 16.3896 19.8684 18.6528 21.5991 20.9705C21.4599 20.9826 21.3752 20.9947 21.2965 20.9947C20.3283 20.9947 19.3601 20.9826 18.3918 21.0008C18.0651 21.0068 17.8654 20.91 17.6717 20.6438C16.6793 19.2822 15.6687 17.9388 14.6581 16.5893C14.5915 16.4985 14.5189 16.4199 14.4221 16.2988C14.18 16.553 13.944 16.795 13.7141 17.0432C12.5522 18.2897 11.3903 19.5303 10.2284 20.7829C10.0893 20.9342 9.94402 21.0189 9.73222 21.0008C9.51437 20.9826 9.29652 20.9947 9.03631 20.9282C10.6702 19.1854 12.298 17.4365 13.9501 15.6695C12.3041 13.4607 10.6641 11.2701 9 9.0371C9.12103 9.025 9.19365 9.0129 9.26626 9.0129C10.295 9.0129 11.3238 9.01895 12.3525 9.00684C12.5825 9.00079 12.7156 9.08551 12.8487 9.26706C13.8351 10.5923 14.8275 11.9115 15.82 13.2368C15.8744 13.3034 15.9289 13.3699 16.0076 13.4607ZM20.0862 20.1899C19.1846 18.9857 18.3313 17.848 17.4781 16.7103C15.8139 14.4834 14.1437 12.2565 12.4735 10.0356C12.407 9.94482 12.3041 9.81774 12.2133 9.81168C11.6868 9.79353 11.1543 9.79958 10.5673 9.79958C10.652 9.92666 10.7065 10.0114 10.761 10.084C11.3056 10.8041 11.8442 11.5242 12.3767 12.2444C14.3011 14.8162 16.2315 17.3881 18.1619 19.9599C18.2284 20.0507 18.3313 20.1778 18.4221 20.1778C18.9546 20.202 19.4871 20.1899 20.0862 20.1899Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1537_339783",
    x: -1.2,
    y: -1.2,
    width: 32.3995,
    height: 32.3995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1537_339783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1537_339783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1537_339783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a6376caae3d1153ffd60e2fff8a9947a.svg";
export { ForwardRef as ReactComponent };